import React, { useRef, useState } from 'react';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { Button, Fab, Stack } from '@mui/material';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
interface storyProps {
    open: boolean,
    storyContent: any,
    handleChangeContent: (value:any) => void,
    handleToggleFullScreen: ()=>void
}

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
    '& .MuiDialog-paper':{
        minWidth: '300px'
    },
}));

export default function StoryDialog({ open, storyContent, handleChangeContent, handleToggleFullScreen }: storyProps) {
    const reactQuillRef = useRef<any>();
    const toolbarOptions = [
        [{ 'size': ['small', false, 'large', 'huge'] }],
        ['bold', 'italic', 'underline','strike', 'blockquote'],
        [{ 'color': [] }, { 'background': [] }], 
        [{ 'align': [] }],
        [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
        ['link', 'image'],
        ['clean'],
      ];
      
    return (
        <>
            <React.Fragment>
                <BootstrapDialog
                    aria-labelledby="customized-dialog-title"
                    open={open}
                    fullScreen={true}
                    maxWidth={'sm'}
                >
                    <DialogTitle sx={{ m: 0, p: 2, fontWeight: '600' }} id="customized-dialog-title">
                        Story
                    </DialogTitle>
                    <Stack direction={'row'} alignItems={'center'}>
                        <IconButton
                            aria-label="close"
                            onClick={handleToggleFullScreen}
                            sx={{
                                position: 'absolute',
                                right: 8,
                                top: 8,
                                color: (theme) => theme.palette.grey[500],
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Stack>
                    <DialogContent dividers>
                    <ReactQuill ref={reactQuillRef} value={storyContent}
                    onChange={handleChangeContent}
                    modules={{ toolbar: toolbarOptions }}
                    style={{
                      height: '80%'
                    }}
                  />
                    </DialogContent>
                </BootstrapDialog>
            </React.Fragment>
        </>
    );
}